export function VacuumCleaner(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth="4">
        <path d="M26 22.5V10c0-3 2-6 6-6s6 3 6 6v24"></path>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M32.75 34h10.5l.75 6H32zM10 40h15.886c.063 0 .114-.05.114-.114V23.255C26 15.935 20.066 10 12.745 10v0A5.745 5.745 0 0 0 7 15.745V29"
        ></path>
        <circle cx="10" cy="34" r="6"></circle>
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 10v19"></path>
      </g>
    </svg>
  );
}

export function BaselineCleanHands(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="m16.99 5l.63 1.37l1.37.63l-1.37.63L16.99 9l-.63-1.37L14.99 7l1.37-.63zM11 6.13V4h2c.57 0 1.1.17 1.55.45l1.43-1.43A4.9 4.9 0 0 0 13 2H7.5v2H9v2.14A5.01 5.01 0 0 0 5.26 9.5h3.98L15 11.65v-.62a5 5 0 0 0-4-4.9M1 22h4V11H1zm19-5h-7l-2.09-.73l.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18c0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8-3c-.01-1.1-.89-2-2-2m0-3c1.1 0 2-.9 2-2s-2-4-2-4s-2 2.9-2 4s.9 2 2 2"
      ></path>
    </svg>
  );
}

export function BaselineDryCleaning(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.56 11.36L13 8.44V7c0-.55-.45-1-1-1s-1-.45-1-1s.45-1 1-1s1 .45 1 1h2c0-1.84-1.66-3.3-3.56-2.95c-1.18.22-2.15 1.17-2.38 2.35c-.3 1.56.6 2.94 1.94 3.42v.63l-6.56 2.92c-.88.38-1.44 1.25-1.44 2.2v.01C3 14.92 4.08 16 5.42 16H7v6h10v-6h1.58c1.34 0 2.42-1.08 2.42-2.42v-.01c0-.95-.56-1.82-1.44-2.21M18.58 14H17v-1H7v1H5.42c-.23 0-.42-.19-.42-.43c0-.17.1-.32.25-.38l6.75-3l6.75 3a.423.423 0 0 1-.17.81"
      ></path>
    </svg>
  );
}

export function OutlineCleaningServices(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 11h-1V3c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v8H8c-2.76 0-5 2.24-5 5v7h18v-7c0-2.76-2.24-5-5-5m-5-8h2v8h-2zm8 18h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H9v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5v-5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3z"
      ></path>
    </svg>
  );
}

export function TravelWafinderSinkWashCleanToiletBathroomWater(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M.5 8.5h13v2a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3v-2h0Zm7-6a2 2 0 0 0-4 0v6m4-4v1"
      ></path>
    </svg>
  );
}

export function FacialCleanser(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth="4">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 34v10h18V34"
        ></path>
        <path d="M31.935 4h-15.95C9.043 4 8.514 8.605 9.25 11.04L14.989 34h17.942s4.644-17.817 5.888-22.96c.589-2.435.09-7.057-6.884-7.04Z"></path>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20.488 19.09c1.64-1.944 2.903-4.631 3.586-6.09c1.196 1.459 3.792 5.118 4.612 7.063c1.025 2.432-1.537 5.35-4.612 5.35c-3.074 0-5.636-3.89-3.586-6.322"
        ></path>
      </g>
    </svg>
  );
}

export function HotelPleaseClean(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="none">
        <path d="M13 27s20 0 20-12v29H13z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M33 15v-1c0-5.523-4.477-10-10-10S13 8.477 13 14m20 1c0 12-20 12-20 12v17h20z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="m19 34l3 3l5-5"
        ></path>
      </g>
    </svg>
  );
}

export function HotelDoNotClean(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="none">
        <path d="M13 27s20 0 20-12v29H13z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M33 15v-1c0-5.523-4.477-10-10-10S13 8.477 13 14m20 1c0 12-20 12-20 12v17h20zM20 32l6 6m0-6l-6 6"
        ></path>
      </g>
    </svg>
  );
}

export function VacuumCleanerTwo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M152.718 28.524q-2.32-.001-4.63.032c-20.528.29-40.464 2.677-58.374 7.902c-28.656 8.36-52.804 24.703-62.717 51.734c-8.846 24.123-1.132 46.174 14.352 63.112s38.137 30.613 62.14 44.273c24.004 13.66 49.415 27.172 70.094 42.21c20.68 15.037 36.234 31.401 42.22 50.093c1.124 3.506.276 14.454-1.921 23.44c-.876 3.58-1.808 6.718-2.65 9.408l17.546 4.234c.84-2.748 1.747-5.924 2.588-9.365c2.488-10.175 5.153-22.05 1.58-33.207c-7.773-24.272-26.598-43.033-48.777-59.16c-22.179-16.128-48.104-29.824-71.775-43.295s-45.032-26.852-57.76-40.776c-12.728-13.923-17.423-26.537-10.736-44.77c7.498-20.448 25.514-33.257 50.857-40.652c25.343-7.394 57.333-8.66 88.924-5.681c31.59 2.98 62.835 10.149 86.8 18.886c10.344 3.771 19.325 7.848 26.303 11.858c3.216-2.397 6.614-4.797 10.184-6.94c2.174-1.305 4.44-2.527 6.808-3.582a108 108 0 0 0-4.23-2.812c-8.89-5.594-20.05-10.75-32.898-15.434c-25.697-9.368-58.118-16.77-91.276-19.898c-10.88-1.026-21.832-1.6-32.652-1.61m175.904 54.288q-.542.018-1.115.076c-3.062.3-6.985 1.828-11.276 4.404c-6.12 3.675-12.542 9.225-19.238 14.213l62.45 84.068l20.247-4.746c-4.262-30.338-14.22-72.644-43.539-95.263c-2.891-2.231-4.996-2.837-7.529-2.752m52.8 116.097l-17.523 4.108l50.264 214.459h18.488zM57.403 318.597l-1.965 18.478c5.836.202 11.85.48 18.011.834l1.852-17.408zm123.183 13.252l-4.99 18.357l60.283 14.621l5.502-18.306zm-146.85 22.818c-.934 0-1.105-.1-2.558 1.904s-3.197 6.092-4.41 11.504c-2.428 10.824-3.016 26.644-2.05 42.448c.967 15.803 3.432 31.755 6.468 43.209c1.517 5.726 3.24 10.363 4.588 12.89c.299.561.328.53.55.854h9.295a56.5 56.5 0 0 1-4.883-23c0-31.374 25.627-57 57-57s57 25.626 57 57a56.5 56.5 0 0 1-4.882 23h90.515c.458-.604 1.316-1.987 2.149-4.3c1.8-5.002 3.313-13.058 4.273-21.694c1.92-17.273 1.945-37.006 1.945-45.006c0-.625-.316-2.017-3.265-4.594s-8.16-5.655-15.002-8.56c-13.686-5.812-33.77-11.127-56.406-15.409c-45.271-8.564-101.032-13.246-140.327-13.246m64 50.809c-21.645 0-39 17.354-39 39c0 21.645 17.355 39 39 39c21.646 0 39-17.355 39-39c0-21.646-17.354-39-39-39m309.563 30l-7 14h50.875l-7-14zm-44.563 32v14h126v-14z"
      ></path>
    </svg>
  );
}

export function Cleaning(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.866 8.116L10.98 6v-.77H9.596V4h4.846q.31 0 .54.23t.23.54v.692l-.885 1.769h-1.923V6.192l-1.846 1.924zM8.789 21v-5.812q0-.16.058-.366q.059-.207.126-.36L12.403 8h1.924q.215.216.339.486q.123.27.123.572V21z"
      ></path>
    </svg>
  );
}

export function CleaningBucketOutline(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.315 22q-.623 0-1.08-.395q-.456-.395-.537-1.003L6.154 9h11.712L16.32 20.602q-.081.608-.54 1.003q-.458.395-1.07.395zm-.026-1h5.423q.23 0 .404-.154q.173-.154.211-.384L16.7 10H7.275l1.398 10.462q.039.23.212.384t.403.154m2.71-5.5q1.04 0 1.771-.73q.731-.728.731-1.77v-1.5h-1V13q0 .617-.441 1.059q-.442.441-1.059.441t-1.059-.441T10.5 13v-1.5h-1V13q0 1.042.729 1.77q.728.73 1.769.73m3.004-8.52q-.415 0-.709-.29T14 5.983t.291-.709t.707-.293t.709.29t.293.708t-.291.709t-.707.293M10 5.98q-.82 0-1.41-.59T8 3.97t.59-1.41t1.42-.58t1.41.58t.58 1.42q0 .819-.58 1.41q-.58.59-1.42.59M14.712 21h-6h6.577z"
      ></path>
    </svg>
  );
}

export function CleaningBucketOutlineTwo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.75 23q-.75 0-1.312-.488t-.663-1.237L5 8h14l-1.775 13.275q-.1.75-.663 1.238T15.25 23zm0-2h6.5l1.45-11H7.275zM12 16q1.25 0 2.125-.875T15 13v-2h-2v2q0 .425-.288.713T12 14t-.712-.288T11 13v-2H9v2q0 1.25.875 2.125T12 16m3-9q-.625 0-1.062-.437T13.5 5.5t.438-1.062T15 4t1.063.438T16.5 5.5t-.437 1.063T15 7m-5-1q-1.05 0-1.775-.725T7.5 3.5t.725-1.775T10 1t1.775.725T12.5 3.5t-.725 1.775T10 6m5.25 15h-6.5z"
      ></path>
    </svg>
  );
}

export function Clean(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M26 20h-6v-2h6zm4 8h-6v-2h6zm-2-4h-6v-2h6z"
      ></path>
      <path
        fill="currentColor"
        d="M17.003 20a4.9 4.9 0 0 0-2.404-4.173L22 3l-1.73-1l-7.577 13.126a5.7 5.7 0 0 0-5.243 1.503C3.706 20.24 3.996 28.682 4.01 29.04a1 1 0 0 0 1 .96h14.991a1 1 0 0 0 .6-1.8c-3.54-2.656-3.598-8.146-3.598-8.2m-5.073-3.003A3.11 3.11 0 0 1 15.004 20c0 .038.002.208.017.469l-5.9-2.624a3.8 3.8 0 0 1 2.809-.848M15.45 28A5.2 5.2 0 0 1 14 25h-2a6.5 6.5 0 0 0 .968 3h-2.223A16.6 16.6 0 0 1 10 24H8a17.3 17.3 0 0 0 .665 4H6c.031-1.836.29-5.892 1.803-8.553l7.533 3.35A13 13 0 0 0 17.596 28Z"
      ></path>
    </svg>
  );
}

export function PersonalHygieneCleanBottleShield(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M23 15.749a7.67 7.67 0 0 1-6 7.5a7.67 7.67 0 0 1-6-7.5V13.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5zm-5.999-.75v4.5m-2.251-2.25h4.501"></path>
        <path d="M8.5 20.253H4a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3h6a3 3 0 0 1 2.925 2.331M1 2.25l.622-.621A3 3 0 0 1 3.741.75h7.009M10 6.751H4v-1.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5zM6.999 3.75v-3"></path>
      </g>
    </svg>
  );
}

export function CleaningBucket(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        color="currentColor"
      >
        <path d="M11 9h8.995c.496 0 .744 0 .89.16c.145.16.126.413.088.917l-.621 8.23c-.132 1.752-.198 2.628-.763 3.16c-.564.533-1.426.533-3.15.533h-4.504c-1.723 0-2.585 0-3.15-.533C7.947 20.675 8.082 19.07 8 18"></path>
        <path d="M11 8.91v5.454c0 1.714 0 2.57-.586 3.104C9.828 18 8.886 18 7 18s-2.828 0-3.414-.532C3 16.935 3 16.078 3 14.364v-.91c0-2.57 0-3.856.879-4.655C4.757 8 6.172 8 9 8h1c.471 0 .707 0 .854.133c.146.133.146.348.146.776"></path>
        <path d="M19 9c0-3.866-2.25-7-5.025-7C11.443 2 9.348 4.608 9 8m-6 6h8m0-1h9"></path>
      </g>
    </svg>
  );
}

export function CleaningTwo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="currentColor">
        <path
          fillRule="evenodd"
          d="M22.062 25.602L11.33 5.416a1 1 0 1 1 1.766-.939l10.733 20.186l1.522-.81a4 4 0 0 1 5.41 1.655l.648 1.219l6.87 10.054l-8.738 4.645l-3.027-5.983l-1.784.903l3.045 6.02l-3.746 1.991l-4.495-11.318l-.647-1.218a4 4 0 0 1 1.654-5.41zm4.227.018l-4.81 2.557a2 2 0 0 0-.827 2.705l.647 1.218l8.343-4.436l-.648-1.217a2 2 0 0 0-2.705-.827"
          clipRule="evenodd"
        ></path>
        <path d="M17.768 35.36a1 1 0 0 0-1.408-.129h.002l-.011.008l-.062.048a6 6 0 0 1-.275.194c-.248.165-.618.39-1.094.616A9.15 9.15 0 0 1 11 37a1 1 0 1 0 0 2a11.15 11.15 0 0 0 4.78-1.097a11 11 0 0 0 1.344-.758a8 8 0 0 0 .47-.34l.03-.023l.01-.008l.003-.004h.002l.001-.002a1 1 0 0 0 .128-1.408m2.064 5.085a1 1 0 0 1-.277 1.387l-.002.002l-.004.002l-.01.006l-.031.02l-.114.073a16 16 0 0 1-1.862.979C16.35 43.439 14.701 44 13 44a1 1 0 1 1 0-2c1.298 0 2.65-.439 3.719-.914a14 14 0 0 0 1.618-.85q.059-.035.086-.054l.02-.012l.002-.002a1 1 0 0 1 1.387.277"></path>
      </g>
    </svg>
  );
}

export function SilverwareClean(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="m15 0l-.62 1.37L13 2l1.38.63L15 4l.63-1.37L17 2l-1.37-.63zm-4.5 2L9.41 4.41L7 5.5l2.41 1.09L10.5 9l1.1-2.41L14 5.5l-2.4-1.09zm8.39 3.14c-1.33-.08-2.85.51-4.05 1.7c-1.59 1.59-2.09 3.74-1.38 5.27L3.7 21.87l1.41 1.41L12 16.41l6.88 6.88l1.41-1.41L13.41 15l1.47-1.47c1.53.71 3.68.21 5.27-1.38c1.91-1.91 2.28-4.65.81-6.12c-.55-.53-1.28-.84-2.07-.89M3.91 5.5a4.01 4.01 0 0 0 0 5.66l4.19 4.18l2.83-2.84z"
      ></path>
    </svg>
  );
}

export function VacuumCleanerThree(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0"></path>
        <path d="M14 9a2 2 0 1 1-4 0a2 2 0 0 1 4 0m-2 7h.01"></path>
      </g>
    </svg>
  );
}
